import {
  getRaceDisplayName,
  getRaceTagColors,
  getTagColors,
} from "@/lib/race-colors"
import { cn } from "@/lib/utils"

interface RaceTagProps {
  race: string
  /** When provided, overrides race-derived hue. */
  hue?: number
  className?: string
}

export function RaceTag({ race, hue, className }: RaceTagProps) {
  const { background, color, borderColor } =
    hue != null ? getTagColors(hue) : getRaceTagColors(race)
  const displayName = getRaceDisplayName(race)

  return (
    <span
      className={cn(
        "inline-block px-1.5 py-0.5 text-[0.625rem] font-semibold tracking-[0.05em] whitespace-nowrap uppercase",
        className,
      )}
      style={{
        background,
        color,
        border: `1px solid ${borderColor}`,
        borderRadius: 0,
      }}
    >
      {displayName}
    </span>
  )
}
